export default {
  List: {
    title: "Cấp phát/Thu hồi",
    Search: "Tìm kiếm nhân viên",
    SearchOrganization: "Tìm kiếm theo mã, tên đơn vị...",
    SearchLocation: "Tìm kiếm vị trí tài sản",
    OrganizationUnit: "Phòng ban",
    Employee: "Nhân viên",
    OrganizationUnitExport: "Danh sách cấp phát/thu hồi theo phòng ban",
    EmployeeExport: "Danh sách cấp phát/thu hồi theo nhân viên",
    LocationExport: "Danh sách cấp phát/thu hồi theo vị trí tài sản",
    Location: "Vị trí tài sản",
    Allocation: "Cấp phát",
    Reduce: "Thu hồi",
    JobPosition2: "Vị trí công việc",
    Organization: "Đơn vị công tác",
    AssetAllocation: "Cấp phát tài sản",
    AssetReduce: "Thu hồi tài sản",
    Delete: "Xóa",
    ErrorReduceEmployee: "Không có tài sản thuộc nhân viên được chọn. Vui lòng kiểm tra lại.",
    ErrorReduceOrganization: "Không có tài sản thuộc phòng ban được chọn. Vui lòng kiểm tra lại.",
  },
  Detail: {
    titleAllocationEmployee: "Cấp phát theo nhân viên",
    titleReduceEmployee: "Thu hồi theo nhân viên",
    titleAllocationOrganiztion: "Cấp phát theo phòng ban",
    titleReduceOrganiztion: "Thu hồi theo phòng ban",
    ProcessDate: "Ngày cấp phát",
    ReduceDate: "Ngày thu hồi",
    Reason: "Lý do cấp phát",
    ReduceReason: "Lý do thu hồi",
    attach: "Đính kèm",
    addEmployee: "Thêm nhân viên",
    assetbyEmployee: "Tài sản được cấp phép",
    attachFile: "Tệp đính kèm",
    addAsset: "Thêm tài sản",
    assetType: "Loại tài sản",
    quantity: "Số lượng thu hồi",
    stockQuantity: "Số lượng chưa sử dụng",
    assetCode: "Mã tài sản",
    assetName: "Tên tài sản",
    location: "Vị trí tài sản",
    specification: "Quy cách",
    addAttach: "Thêm đính kèm",
    addDetail: "Thêm dòng",
    fileName: "Tệp đính kèm",
    size: "Dung lượng",
    dowload: "Tải về",
    quickSelect: "Chọn nhanh",
    file: "tệp",
    Representative: "Người đại diện",
    ViewAssess: "Xem định mức",
    inStock: "Tồn",
    inStockQuantity: "Số lượng chưa sử dụng",
    Allocation: "Cấp phát",
    LocationCode: "Mã vị trí",
  },

  ListTab: {
    GeneralInfo: "Thông tin chung",
    AssetUsing: "Tài sản đang sử dụng",
    AssetManaging: "Tài sản đang quản lý",
    AllocationHistory: "Lịch sử cấp phát",
    ListSuggestedLiquidation: "DS tài sản đề nghị thanh lý",
    ListLiquidation: "DS tài sản thanh lý",
    UsingAssets: "Tài sản đã cấp phát",
    SpareAssets: "Tài sản chưa cấp phát",
    EmployeeAsset: "Tài sản cấp cho nhân viên",
    OrganizationUnitAsset: "Tài sản cấp cho phòng ban",
    AssetForEmployee: "Tài sản cấp cho nhân viên",
    AssetForOrganizationUnit: "Tài sản cấp cho phòng ban",
  },
  LayoutGrid: {
    AssetCode: "Mã tài sản",
    AssetName: "Tên tài sản",
    Location: "Vị trí tài sản",
    Specification: "Quy cách",
    Amount: "Số lượng",
    Status: "Tình trạng",
    ProcessDate: "Ngày cấp phát",
    Reason: "Lý do",
    Action: "Hành động",
    Business: "Nghiệp vụ",
    Handover: "Người bàn giao",
    TakeHandover: "Người nhận bàn giao",
    AssetPermission: "Quyền tài sản",
    ConfirmStatus: "Tình trạng xác nhận",
    LostDate: "Ngày mất",
    CancelDate: "Ngày hủy",
    CancelBy: "Hủy bởi",
    ConfirmBy: "Xác nhận bởi",
    SuggestedLiquidationDate: "Ngày đề nghị thanh lý",
    SuggestionBy: "Đề nghị bởi",
    LiquidatedDecisionDate: "Ngày quyết định thanh lý",
    LiquidatedDate: "Ngày thanh lý",
    LiquidatedBy: "Xác nhận thanh lý bời",
    AllocationDate: "Ngày sử dụng",
    AssetUser: "Người sử dụng",
  },
  Allocation: {
    TitleAsset: "Thông tin tài sản",
    AssetCode: "Mã tài sản",
    AssetName: "Tên tài sản",
    AssetType: "Loại tài sản",
    PurchaseDate: "Ngày mua",
    Status: "Tình trạng",
    SeriaNumberAsset: "Quy cách tài sản",
    AssetAllocationInfo: "Thông tin cấp phát tài sản",
    AllocationDate: "Ngày cấp phát",
    AllocationQuantity: "Số lượng cấp phát",
    AssetLocation: "Vị trí tài sản",
    AllocatedTo: "Cấp phát cho",
    Serial: "Số seri",
    Specification: "Quy cách tài sản",
    WarrantyPeriod: "Hạn bảo hành",
    OrgPrice: "Giá trị tài sản",
    RemainingAmount: "Giá trị còn lại",
    UsedOrganizationUnitName: "Đơn vị sử dụng",
    Represent: "Người đại diện",
    EmployeeName: "Người sử dụng",
    Employee: "Nhân viên",
    OrganizationUnit: "Phòng ban",
  },
  Reduce: {
    AssetName: "Tên tài sản",
    AssetCode: "Mã tài sản",
    AssetLocation: "Vị trí tài sản",
    AssetReduceInfo: "Thông tin thu hồi tài sản",
    DetailInfo: "Số lượng thu hồi",
    ReduceQuantity: "Số lượng thu hồi",
    ReduceReason: "Lý do thu hồi",
    ReduceDate: "Ngày thu hồi",
    ObjectUsing: "Đối tượng sử dụng",
    EmployeeUsing: "Nhân viên sử dụng",
    OrganizationUsing: "Đơn vị sử dụng",
    Representor: "Người sử dụng",
    Using: "Đang sử dụng",
    Reduce: "Thu hồi",
    AssetStatus: "Tình trạng",
    Quantity: "Số lượng",
    AllocationType: "Đối tượng sử dụng",
    EmployeeName: "Nhân viên sử dụng",
    UsedOrganizationUnitName: "Đơn vị sử dụng",
    Represent: "Người đại diện",
    AllocationDate: "Ngày cấp phát",
    EmployeeCode: "Mã nhân viên SD",
    EmployeeCodeTooltip: "Mã nhân viên sử dụng",
    UsedOrganizationUnitCode: "Mã phòng ban SD",
    UsedOrganizationUnitCodeTooltip: "Mã phòng ban sử dụng",
    UsedOrganizationUnit: "Phòng ban sử dụng",
    RepresentativeCode: "Mã người ĐD",
    RepresentativeCodeTooltip: "Mã người đại diện",
  },
  Validate: {
    ErrorAllocation: "Chỉ được cấp phát tài sản Chưa sử dụng",
    ErrorAllocationAssetBalance: "Tài sản đã được cấp phát hết",
    ErrorReduceAssetBalance: "Tài sản chưa được cấp phát",
    ErrorInactiveOrganizationUnit: "Chỉ được phép cấp phát tài sản cho phòng ban đang sử dụng.",
    ErrorInactiveEmployee: "Chỉ được phép cấp phát tài sản cho nhân viên đang sử dụng.",
    ErrorReduce:
      "Chỉ được phép thu hồi tài sản Đang sử dụng, Hỏng, Báo hỏng hoặc Đề nghị thanh lý.",
    ErrorAllocatedDateLessThanPurchaseDate: "Ngày cấp phát phải lớn hơn hoặc bằng ngày mua.",
    ErrorReduceDate: "Ngày thu hồi phải lớn hơn hoặc bằng ngày mua và ngày cấp phát",
    ErrorNullReduceDate: "Tài sản thu hồi bắt buộc phải có ngày thu hồi",
    ErrorLocation: "Tài sản chỉ được thu hồi đến vị trí tài sản ở cấp chi tiết nhất",
    NotOrganizationUnit:
      "Tài sản đã cấp phát cho Phòng ban bắt buộc phải có Phòng ban nhận cấp phát",
    NotEmployee: "Tài sản đã cấp phát cho Nhân viên bắt buộc phải có Nhân viên nhận cấp phát",
    ErrorAllocationLocation: "Tài sản chỉ được cấp phát đến vị trí tài sản ở cấp chi tiết nhất",
    ErrorAllcationEmployee:
      "Tài sản đã cấp phát cho nhân viên bắt buộc phải có nhân viên nhận cấp phát.",
    ErrorAllcationOrgUnit: "Tài sản chỉ được cấp phát cho phòng ban ở cấp chi tiết nhất.",
    ErrorTotalQuantity:
      "Số lượng thu hồi phải bằng tổng số lượng thu hồi của tất cả các phòng ban, nhân viên sử dụng",
    ErrorTotalQuantityAllocation:
      "Số lượng cấp phát phải bằng tổng số lượng cấp phát của tất cả các phòng ban, nhân viên sử dụng",
    ErrorQuantity: "Số lượng thu hồi không được lớn hơn số lượng tồn",
    ErrorNotPickAsset: "Chưa chọn tài sản để cấp phát.",
    ErrorAllocationQuantity: "Số lượng cấp phát không được lớn hơn số lượng tồn",
    ErrorAllocationQuantityFromOneToRemainQuantity:
      "Số lượng cấp phát phải lằm trong khoảng từ 1 đến {0}",
    ErrorReduceQuantity: "Số lượng thu hồi không được lớn hơn số lượng tồn",
    ErrorReduceQuantityFromOneToRemainQuantity:
      "Số lượng thu hồi phải nằm trong khoảng từ 1 đến {0}",
    ErrorDuplicateAsset: "Cùng một tài sản không được trùng vị trí tài sản.",
    ErrorSelectDetail: "Tài sản thu hồi chưa được chọn.",
    ErrorQuantityReduce: "Số lượng tài sản thu hồi bằng 0",
    ErrorSelectDetailAllocation: "Tài sản cấp phát chưa được chọn.",
    ErrorNullLiquidationDate: "Tài sản thanh lý bắt buộc phải có ngày thanh lý",
    ErrorNullRequestLiquidationDate: "Ngày đề nghị thanh lý không được phép bỏ trống",
    ErrorIncrement: "Chỉ tăng số lượng của tài sản quản lý theo số lượng. Vui lòng chọn lại.",
    ErrorIncurredUsageHistory: "Không thể xóa do tài sản đã phát sinh nghiệp vụ tiếp theo.",
    WarningDeleteUsageHistory:
      "Khi xóa nghiệp vụ này, tài sản sẽ được cập nhật lại thông tin trước khi thực hiện <{0}>. Bạn có chắc chắn muốn xóa?",
    HasRaiseWhenDeleteCanNotDelete: "Không thể xóa do tài sản đã phát sinh nghiệp vụ tiếp theo.",
    ErrorDeleteLocation:
      "Vị trí tài sản đã phát sinh nghiệp vụ. Vui lòng xóa các nghiệp vụ trước khi xóa vị trí tài sản.",
    ErrorLocationOrg: "Tài sản chỉ được cấp phát cho vị trí tài sản ở cấp chi tiết nhất",
    ErrorOrg: "Tài sản chỉ được cấp phát cho phòng ban ở cấp chi tiết nhất",
    ErrorQuantityAllocation: "Đã hết tài sản để cấp phát. Vui lòng kiểm tra lại.",
    ErrorAllocationDateLessThanOccurenceDate:
      "Ngày cấp phát không được nhỏ hơn ngày phát sinh nghiệp vụ gần nhất, tức ngày ##0##",
    ErrorOrgInactive: "Tài sản chỉ được cấp phát cho phòng ban đang theo dõi",
    ErrorOrgInactiveReduce: "Tài sản chỉ được thu hồi cho phòng ban đang theo dõi",
  },
};
